<span [className]="cssClassName">{{statusName | playerStatus}}</span>
